import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import backgroundImage from '../Images/image.jpg';

const Home = () => {
  return (
    <div className="home">
      <div className="background-image" style={{ backgroundImage: `url(${backgroundImage})` }} />
      <div className="hero">
        <div className="hero-content">
          <h1 className="glitch" data-text="Yohannes Taye">Yohannes Taye</h1>
          <p className="tagline">Machine Learning | AI Engineer</p>
          <div className="hero-buttons">
            <Link to="/projects" className="btn">Explore My Projects</Link>
            <Link to="https://drive.google.com/file/d/1vXbxaXROJTit0hjNLJiprRtDDHq-693R/view?usp=sharing" className="btn btn-outline">Download CV</Link>
          </div>
        </div>
        <div className="tech-stack">
          <div className="tech-item">Python</div>
          <div className="tech-item">Scikit-learn</div>
          <div className="tech-item">TensorFlow</div>
          <div className="tech-item">PyTorch</div>
          <div className="tech-item">REST API</div>
          <div className="tech-item">MCP</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
